var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ec8d8d",
    width: "800px",
    height: "800px",
    viewBox: "-2.6 -2.6 57.20 57.20",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ec8d8d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#cc3636",
    strokeWidth: 2.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,0A26,26,0,1,0,52,26,26,26,0,0,0,26,0Zm0,48A22,22,0,1,1,48,26,22,22,0,0,1,26,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.83,26l8.58-8.59a2,2,0,0,0-2.82-2.82L26,23.17l-8.58-8.58a2,2,0,0,0-2.83,2.82L23.17,26l-8.58,8.58a2,2,0,1,0,2.82,2.83L26,28.83l8.59,8.58A2,2,0,0,0,36,38a2,2,0,0,0,1.42-.59,2,2,0,0,0,0-2.82Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,0A26,26,0,1,0,52,26,26,26,0,0,0,26,0Zm0,48A22,22,0,1,1,48,26,22,22,0,0,1,26,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.83,26l8.58-8.59a2,2,0,0,0-2.82-2.82L26,23.17l-8.58-8.58a2,2,0,0,0-2.83,2.82L23.17,26l-8.58,8.58a2,2,0,1,0,2.82,2.83L26,28.83l8.59,8.58A2,2,0,0,0,36,38a2,2,0,0,0,1.42-.59,2,2,0,0,0,0-2.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.a456c0a45b205eda23ff60a11035da14.svg";
export { ForwardRef as ReactComponent };